// cpfPaciente,  
// nomePaciente,
// sexoPaciente,
// dataNascimentoPaciente,
// emailPaciente, 
// dddCelularPaciente,
// numeroCelularPaciente, 

//import { format } from "date-fns"
import { format } from "date-fns"
import { date, isValidCPF } from "./utils"

export const fieldsSchema = {
    cpfPaciente: {
        value: '',
        types: (value) => {
            const cpf = value.replace(/\D/g, '')
            const hasCpfValid = isValidCPF(cpf)
            
            if (!hasCpfValid) {
                return 'Por favor, digite um CPF válido'
            } else {
                return ''
            }
        },
        helperText: '',
        error: false,  
        errors: [],
    }, 
    nomePaciente: {
        value: '',
        types: value => {
            if (value.length === 0) { 
                return 'O campo é requerido e não pode ficar vazio' 
            } else if (value.length < 10) { 
                return 'O campo deve contér mais de 10 caracteres' 
            } else {
                return ''
            }
        },
        helperText: '',
        error: false,  
        errors: [],
    },  
    sexoPaciente: {
        value: '',
        types: value => {
            if (!value) { 
                return 'O campo é requerido e não pode ficar vazio' 
            } else if (!['m', 'f'].includes(value.toLowerCase())) { 
                return 'O só pode ser uma das opções [M, F]' 
            } else {
                return ''
            }
        },
        helperText: '',
        error: false,  
        errors: [],
    }, 
    dataNascimentoPaciente: {
        value: '',
        types: val => {
         
            const { isValidDate } = date(val)
           
            if (!val) { 
                return 'O campo é requerido e não pode ficar vazio' 
            } else if (!isValidDate) { 
                return 'Digite uma data válida' 
            } else {
                return ''
            }
        },
        render: value => {
            return format(value, 'dd/MM/yyy')
        },
        helperText: '',
        error: false,  
        errors: [],
    },  
    emailPaciente: {
        value: '',
        types: value => {
            const regexEmail = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
            if (!value) { 
                return 'O campo é requerido e não pode ficar vazio' 
            } else if (!regexEmail.test(value)) {
                return 'Digite um email válido'   
            } else {
                return ''
            }
        },
        helperText: '',
        error: false,  
        errors: [],
    },  
    dddCelularPaciente: {
        value: '',
        types: value => {
            if (!value) { 
                return 'Preencha' 
            } else if (value.length < 2) {  
                return 'Preencha'    
            } else {
                return ''
            }
        },
        helperText: '',
        error: false,  
        errors: [],
    }, 
    numeroCelularPaciente: {
        value: '',
        types: value => {
            if (!value) { 
                return 'O campo é requerido e não pode ficar vazio' 
            } else if (value.length < 8) {  
                return 'O total de caracteres não pode ser menor que 8'    
            } else {
                return ''
            }
        },
        helperText: '',
        error: false,  
        errors: [],
    }, 
}

const initialState = {
    progress: 0,
    items: [],
    perfis: [],
    profissionais: [],
    dias: [],
    diaEscolhido: '',
    especialidades: [],
    idEspecialidade: '',
    planos: '',
    idPlano: '',
    idConvenio: '',
    isConvenio: false,
    idPessoa: '',
    idAgenda: '',
    horarioAgenda: '',
    dataAgenda: '',
    nomeProfissional: '',
    convenios: [], 
    unidades: [],
    error: null,
    userExists: true,
    loading: true,
    message: '',

    cpfPaciente: '',
    nomePaciente: '',
    sexoPaciente: '',
    dataNascimentoPaciente: null,
    emailPaciente: '',
    dddCelularPaciente: '', 
    numeroCelularPaciente: '',

    currentPath: '',
    historyPaths: new Set([])
    
}

export default initialState